var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 16.35V6.15C33 3.9 32.04 3 29.655 3H23.595C21.21 3 20.25 3.9 20.25 6.15V16.35C20.25 18.6 21.21 19.5 23.595 19.5H29.655C32.04 19.5 33 18.6 33 16.35Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 29.85V27.15C33 24.9 32.04 24 29.655 24H23.595C21.21 24 20.25 24.9 20.25 27.15V29.85C20.25 32.1 21.21 33 23.595 33H29.655C32.04 33 33 32.1 33 29.85Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 19.65V29.85C15.75 32.1 14.79 33 12.405 33H6.345C3.96 33 3 32.1 3 29.85V19.65C3 17.4 3.96 16.5 6.345 16.5H12.405C14.79 16.5 15.75 17.4 15.75 19.65Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 6.15V8.85C15.75 11.1 14.79 12 12.405 12H6.345C3.96 12 3 11.1 3 8.85V6.15C3 3.9 3.96 3 6.345 3H12.405C14.79 3 15.75 3.9 15.75 6.15Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.8382e33ad3970c195f3ff3499b7b9aaf.svg";
export { ForwardRef as ReactComponent };